/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Regenerate_TitleInputs */

const en_two_fa_regenerate_title = /** @type {(inputs: Two_Fa_Regenerate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate Two-Factor Authentication`)
};

const nl_two_fa_regenerate_title = /** @type {(inputs: Two_Fa_Regenerate_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twee-factor-authenticatie opnieuw genereren`)
};

/**
* | output |
* | --- |
* | "Regenerate Two-Factor Authentication" |
*
* @param {Two_Fa_Regenerate_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_regenerate_title = /** @type {((inputs?: Two_Fa_Regenerate_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Regenerate_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_regenerate_title(inputs)
	return en_two_fa_regenerate_title(inputs)
});